import { useStore } from "@/store/store";
import { useMemo } from "react";

export const useBasicFlags = () => {
  const user = useStore.use.user();
  const isSuperuser = !!user?.is_superuser;
  const entity = user?.entity;
  const featureShowHideFlag = useStore((state) => state.featureShowHideFlag);

  // Memoize the entire object to ensure stability
  return useMemo(
    () => ({ isSuperuser, entity, featureShowHideFlag, user }),
    [isSuperuser, entity, featureShowHideFlag, user],
  );
};
